import ValidationUtil from "../util/ValidationUtil";
import IValidationRule from "./ValidationRule";

export default class ValidationRuleRequired implements IValidationRule {
  private _message: string | undefined;

  public get message(): string | undefined {
    return this._message;
  }

  public check(value: any): boolean {
    this._message = undefined;

    if (!ValidationUtil.isNotEmpty(value)) {
      this._message = `필수입력값입니다.`;

      return false;
    }

    return true;
  }
}
